module.exports = __webpack_public_path__ + "static/media/help3.1c079273.png";